import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { sizes } from "et3-ui-library";

import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import {
  getPickerOptionLabel,
  getPickerSelectedOption
} from "../../../../../helpers/et3-picker-data-helper";
import {
  TEt3PickerOption,
  TEt3PickerSingleValue
} from "../../../../../TypesNEW";

const FilterSelect = withLiteObserverAndTheme<{
  label: string;
  options: TEt3PickerOption[];
  value: TEt3PickerSingleValue;
  onChange: (value: TEt3PickerSingleValue) => void;
}>((props) => {
  const { label, options, value, onChange } = props;

  return (
    <Autocomplete
      size="small"
      fullWidth
      disableClearable
      openOnFocus
      autoHighlight
      options={options}
      value={getPickerSelectedOption(options, value)}
      getOptionLabel={getPickerOptionLabel}
      isOptionEqualToValue={(option, selected) =>
        option.value === selected.value
      }
      onChange={(_, option) => onChange(option)}
      noOptionsText={i18n.get("NO_RESULT")}
      openText={i18n.get("KHATTABAT_SELECT_OPEN")}
      closeText={i18n.get("KHATTABAT_SELECT_CLOSE")}
      slotProps={{
        listbox: { sx: { maxHeight: sizes.multiSelect.listMaxHeight } }
      }}
      renderInput={(params) => <TextField {...params} label={label} />}
    />
  );
});

export default FilterSelect;
